const PriceUnits = {
  DollarsPerGallon: 'dollars_per_gallon',
  DollarsPerLiter: 'dollars_per_liter',
  CentsPerLiter: 'cents_per_liter',
};

export default PriceUnits;
